import { apiHelper } from '@/utils';
import { API } from '@/constants';

const URL = `${API.BASE_URL_API}/v1`;
export const catalogCategoryService = { getAll, store, show, update, updateStatus, softDelete };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy
    };
    if (filter.searchArray?.length) {
        params.search_words = filter.searchArray;
    }
    return apiHelper(URL).get('/catalog-categories', { params });
}
export function store(data) {
    return apiHelper(URL).post('/catalog-categories', { name: data.name });
}
export function show(uuid) {
    return apiHelper(URL).get(`/catalog-categories/${uuid}`);
}
export function update(data) {
    return apiHelper(URL).put(`/catalog-categories/${data.uuid}`, { name: data.name });
}
export function updateStatus(uuid, isActive) {
    return apiHelper(URL).patch(`/catalog-categories/${uuid}`, { is_active: isActive ? 1 : 0 });
}
export function softDelete(uuid) {
    return apiHelper(URL).patch(`/catalog-categories/delete/${uuid}`);
}
